import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';
export function useEventCallback(handler) {
  const $ = _c(2);
  const handlerRef = useRefWithCurrentValue(handler);
  let t0;
  if ($[0] !== handlerRef) {
    t0 = (...t1) => {
      const args = t1;
      return handlerRef.current(...args);
    };
    $[0] = handlerRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0 as T;
}